export default __webpack_public_path__ + "static/36-33c3c0a7bd0c51b938f949ab8fb1b41d.png";